module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading && !_vm.card.title) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('section', {
    staticClass: "c-card c-card--report"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [(_vm.card.title) ? _c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.card.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body u-position-relative"
  }, [(!_vm.dataAvailable) ? _c('p', {
    staticClass: "u-small-paragraph"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('web.card_report.data_not_available')) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.dataAvailable && _vm.card.download_enabled && !_vm.downloading) ? _c('button', {
    staticClass: "c-button c-button--dataTables-custom-download-button t-button-secondary",
    on: {
      "click": _vm.downloadReport
    }
  }, [_vm._v("\n    " + _vm._s(_vm.card.download_button_text) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.downloading) ? _c('button', {
    staticClass: "c-button c-button--dataTables-custom-download-button download-button-loading t-button-secondary"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-1x t-loading-icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.$t(_vm.loadingMessage)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataAvailable),
      expression: "dataAvailable"
    }]
  }, [_c('table', {
    ref: "dtable",
    staticStyle: {
      "min-width": "100%"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fb2df8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/cards/Report.vue
// module id = 542
// module chunks = 1